export const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    draggable: false, // on desktop, do not allow to move the carrousel via mouse-dragging
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } },
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2, dots: true } }
    ]
};
